// What's New tabs (port of inline script index.html 745-774).
function initWhatsNewTabs() {
  const tabs = Array.from(document.querySelectorAll('#whats-new-tabs .wn-tab'));
  const panels = document.querySelectorAll('[data-wn-panel]');
  if (!tabs.length || !panels.length) return;
  const alphaFor = d => d === 1 ? '.55' : d === 2 ? '.28' : '.15';
  function setActive(t, opts) {
    const userTriggered = !!(opts && opts.userTriggered);
    const activeIdx = tabs.indexOf(t);
    const key = t.getAttribute('data-wn-tab');
    tabs.forEach((x, i) => {
      x.classList.toggle('tab-active', x === t);
      x.style.setProperty('--tab-alpha', x === t ? '1' : alphaFor(Math.abs(i - activeIdx)));
    });
    // Auto-scroll tabu do centrum strip — TYLKO na klik usera, NIGDY na init.
    // (block:'nearest' + scrollIntoView na load pchało body scroll do sekcji What's New
    //  zamiast top of page → wyglądało jak chaos scroll na mobile.)
    if (userTriggered && window.matchMedia('(max-width: 767px)').matches) {
      try { t.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' }); } catch (e) { /* no-op */ }
    }
    panels.forEach(p => {
      const match = p.getAttribute('data-wn-panel') === key;
      p.classList.toggle('hidden', !match);
      p.classList.toggle('grid', match);
    });
  }
  const initial = tabs.find(t => t.classList.contains('tab-active')) || tabs[0];
  setActive(initial);
  tabs.forEach(t => t.addEventListener('click', () => setActive(t, { userTriggered: true })));
}

if (document.readyState !== 'loading') initWhatsNewTabs();
else document.addEventListener('DOMContentLoaded', initWhatsNewTabs);
